/**
 * sessionStorage keys for the tracked Context Console accuracy run, and the
 * function that clears them — split out from `EvaluationJobContext.tsx` so
 * consumers that only need "wipe this on sign-out" (AuthContext) don't pull
 * in that file's whole module graph (`EvaluationCompleteToast`,
 * `useContextConsole`, the react-query hooks) into their own bundle for
 * three `sessionStorage.removeItem` calls.
 */

export const EVALUATION_JOB_STORAGE_KEY = "context-console-eval-job-id";
export const EVALUATION_JOB_SET_ID_STORAGE_KEY = "context-console-eval-job-set-id";
export const EVALUATION_JOB_VIEWED_STORAGE_KEY = "context-console-eval-job-viewed";
/** When the currently tracked job started (`Date.now()`, as a string) — lets
 * the elapsed-time display survive a refresh instead of resetting to 0. */
export const EVALUATION_JOB_STARTED_AT_STORAGE_KEY = "context-console-eval-job-started-at";

/**
 * Wipe this tab's tracked accuracy-run id, independent of whether a provider
 * instance is even mounted. For the logout path: on a shared machine, a job
 * id resumed by the next signed-in user's `EvaluationJobProvider` would poll
 * another company's run — backend authz should reject that, and a dead poll
 * self-clears without a toast regardless, but the result carries per-question
 * answers, so it shouldn't survive a sign-out to begin with.
 *
 * This only covers the persisted half of that leak. `EvaluationJobProvider`
 * is keyed on the signed-in user (`ContextConsoleProviders.tsx`) so a same-
 * tab account switch also resets its in-memory `run`/`hasBeenViewed` state,
 * which this function — a plain storage wipe — cannot reach.
 */
export const clearEvaluationJobStorage = () => {
  sessionStorage.removeItem(EVALUATION_JOB_STORAGE_KEY);
  sessionStorage.removeItem(EVALUATION_JOB_SET_ID_STORAGE_KEY);
  sessionStorage.removeItem(EVALUATION_JOB_VIEWED_STORAGE_KEY);
  sessionStorage.removeItem(EVALUATION_JOB_STARTED_AT_STORAGE_KEY);
};
